import { render, staticRenderFns } from "./AdvertCoverageList.vue?vue&type=template&id=53718bf0&scoped=true&"
import script from "./AdvertCoverageList.vue?vue&type=script&lang=js&"
export * from "./AdvertCoverageList.vue?vue&type=script&lang=js&"
import style0 from "./AdvertCoverageList.vue?vue&type=style&index=0&id=53718bf0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53718bf0",
  null
  
)

export default component.exports